import React, { FunctionComponent, useMemo } from 'react';
import MediaFile, { FileType } from '@interfaces/MediaFile';
import { FolderOpenFilled, VideoCameraFilled } from '@ant-design/icons';
import Image from '@components/Image';

import css from './ViewFiles.module.less';

interface PreviewFilesProps {
  files: MediaFile[];
  altText?: string;
}

const ViewFiles: FunctionComponent<PreviewFilesProps> = ({ files, altText }) => {
  const header = useMemo(() => {
    if (files?.length > 1) {
      return (
        <div className={css.overlayHeader}>
          <FolderOpenFilled />
        </div>
      );
    }
    if (files?.length === 1 && files?.[0].fileType === FileType.Video) {
      return (
        <div className={css.overlayHeader}>
          <VideoCameraFilled />
        </div>
      );
    }
    return null;
  }, [files]);

  const image = useMemo(() => {
    const media = files?.[0];
    if (media?.fileType === FileType.Video && !media?.image?.url) {
      return (
        <video
          className={css.image}
          src={media.url}
        />
      );
    }
    if (media?.image?.url)
      return (
        <Image
          className={css.image}
          url={media?.image?.url || ''}
        />
      );

    return <div className={css.altText}>{altText ? altText : 'Not found'}</div>;
  }, [files]);
  return (
    <div className={css.viewFiles}>
      {header}
      {image}
    </div>
  );
};

export default ViewFiles;
